export default {
  columns: {
    strategy: 'Strategy',
    source: 'Source',
    async: 'Async',
    content: 'Content',
    edit: 'Edit',
    delete: 'Delete',
  },
  buttons: {
    add_script: 'Add Script',
  },
};
